var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("footer", [
    _c(
      "div",
      { staticClass: "footer-links no-print" },
      [
        _c("router-link", { attrs: { to: "/about/legal/#termsOfUse" } }, [
          _vm._v("Terms"),
        ]),
        _vm._v(" "),
        _c("router-link", { attrs: { to: "/about/legal/#privacy" } }, [
          _vm._v("Privacy"),
        ]),
        _vm._v(" "),
        _c("router-link", { attrs: { to: "/about/contact" } }, [
          _vm._v("Contact"),
        ]),
      ],
      1
    ),
    _vm._v(" "),
    _c("img", {
      staticStyle: { display: "none" },
      attrs: {
        height: "1",
        width: "1",
        alt: "",
        src: "https://px.ads.linkedin.com/collect/?pid=2807145&fmt=gif",
      },
    }),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }